import React from 'react';
import { LinkProps } from '@mui/material';
import ZeusLink from './ZeusLink';
import { formatDate } from '../../utils/dateFormatting';

interface ZeusIncidentLinkProps extends Omit<LinkProps, 'href' | 'children'> {
  incident: {
    id: number;
    incidentDate: string;
  };
}

export default function ZeusIncidentLink({ incident, ...linkProps }: ZeusIncidentLinkProps) {
  return (
    <ZeusLink path={`/supervisor-incidents/${incident.id}`} {...linkProps}>
      {formatDate(incident.incidentDate)}
    </ZeusLink>
  );
}
